import React, { useMemo, useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import { useLazySimpleUserQuery } from '../../../../graphql/graphql';

interface Props {
	userId: string;
	customClass?: string;
	type?: 'img' | 'background';
	profileImageUrl?: string;
}

const UserAvatar: React.FC<Props> = ({
	userId,
	customClass = undefined,
	type = 'img',
	profileImageUrl,
}) => {
	const [avatarUrl, setAvatarUrl] = useState<string>(
		'/dist/placeholder/user-placeholder.png',
	);
	const [getSimpleUser] = useLazySimpleUserQuery();

	const fetchedProfileImageUrl = useMemo(async () => {
		if (profileImageUrl) {
			return profileImageUrl;
		}
		if (userId) {
			const { user } = await getSimpleUser({
				id: userId,
			}).unwrap();
			return user?.profileImageUrl ?? '/dist/placeholder/user-placeholder.png';
		} else {
			return profileImageUrl ?? '/dist/placeholder/user-placeholder.png';
		}
	}, [userId]);

	useEffectAsync(async () => {
		if (profileImageUrl) {
			setAvatarUrl(profileImageUrl);
		} else if (userId) {
			setAvatarUrl(await fetchedProfileImageUrl);
		}
	});

	return type === 'img' ? (
		<img src={avatarUrl} alt={'avatar'} className={customClass} />
	) : (
		<div
			className={customClass}
			style={{ backgroundImage: `url("` + avatarUrl + `")` }}
		/>
	);
};

export default UserAvatar;
